export default __webpack_public_path__ + "static/media/img-0482-andorra-full-face.64a3402f.png";